import React, { useState, useEffect, useContext } from "react";
import useHttp from "../hooks/use-http";
import AuthContext from "./auth-context";
import { API_NEW_URL } from "../constants/constants";
import { maybeRefreshDomainConfig } from "../utils/domainConfig";

export const DomainDataContext = React.createContext();

const DomainDataContextProvider = (props) => {
  const [inviteData, setinviteData] = useState({
    hasError: false,
    isLoading: true,
  });
  const ondomainData = (data) => {
    if (data.errorStatus) {
      data.isLoading = false;
      data.hasError = true;
    } else {
      // zafClient.metadata().then(function (metadata) {
      //   console.log("metadata");
      //   console.log(metadata.settings);
      //   if (metadata.settings.apikey) {

          data.isLoading = false;
          data.hasError = false;
          data.apikey = '';
          if (data.data) {
            if (data.data.COUNTRYCODE == "UK") {
              data.data.COUNTRYCODE = "gb";
            }
          }
          if (data.data.TEAMS.length == 0) {
            data.hasError = true;
            data.message =
              "You are not part of any Collaboration Profiles, please contact your administrator.";
          }
        // }else{
        //   data.hasError = true;
        //     data.message =
        //       "API Key not found in App Setting.";
        // }
      // });
    }

    setinviteData(data);
    console.info(data);
  };
  const { isLoading, error, sendRequest } = useHttp();
  const authCtx = useContext(AuthContext);

  // Maps new API shape → legacy TEAMS/COUNTRYCODE shape so downstream
  // consumers (Profiles, InviteTab, SmsForm, WhatsappForm) stay unchanged.
  // Claude recommended keeping this adapter for the migration PR —
  // refactoring all four consumers to the new camelCase shape would be a
  // large diff; safer to do as a follow-up once the new API is stable in prod.
  const adaptToOldShape = (profilesData, countriesData) => {
    const items = (profilesData && profilesData.items) || [];
    const countriesList = Array.isArray(countriesData)
      ? countriesData
      : (countriesData && countriesData.items) || [];
    const defaultCountry =
      countriesList.find((c) => c && c.isDefault) || countriesList[0] || {};
    const isoCountry = (defaultCountry.countryCode || "").toLowerCase();
    // Blitzz API uses "UK" for British; intl-tel-input only knows the
    // standard ISO "gb". Normalize here so SmsForm/WhatsappForm don't break.
    return {
      data: {
        COUNTRYCODE: isoCountry === "uk" ? "gb" : isoCountry,
        ISOCODE: defaultCountry.isoCode || "",
        TEAMS: items.map((it) => ({
          TEAMID: it.collaborationProfileId,
          TITLE: it.name || it.title,
          SMSTEMPLATE: it.smsTemplate || "",
          SHOWMECONFIGS: {
            DEFAULTINVITETYPE: it && it.configurations && it.configurations.DEFAULTINVITETYPE,
            WHATSAPPINVITE: it && it.configurations && it.configurations.WHATSAPPINVITE,
            SMSINVITE: it && it.configurations && it.configurations.SMSINVITE,
            EMAILINVITE: it && it.configurations && it.configurations.EMAILINVITE,
          },
        })),
      },
    };
  };

  const getDomainData = () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + authCtx.token,
      usertoken: authCtx.token,
      clientappid: process.env.REACT_APP_CLIENTID,
    };
    Promise.all([
      fetch(API_NEW_URL + "collaborationprofiles/own", {
        method: "GET",
        headers,
      }),
      fetch(API_NEW_URL + "helper/countries", {
        method: "GET",
        headers,
      }),
    ])
      .then(async ([profilesRes, countriesRes]) => {
        // SA-change check: either response's header can trigger a config refetch.
        maybeRefreshDomainConfig(profilesRes.headers);
        maybeRefreshDomainConfig(countriesRes.headers);
        if (profilesRes.status === 401 || countriesRes.status === 401) {
          // Surface the BE's own message on 401 so the user sees the actual
          // recovery action (e.g. re-authorize Blitzz). Do NOT add
          // authCtx.clearData() here — it triggers a route-driven re-auth
          // loop that produced 1M+ 401s/day in prod.
          const failed =
            profilesRes.status === 401 ? profilesRes : countriesRes;
          let beMessage = "";
          try {
            const body = await failed.json();
            beMessage = body?.error?.message || body?.message || "";
          } catch {
            // Non-JSON body — fall back to the generic message below.
          }
          ondomainData({
            errorStatus: -1,
            message: beMessage || "Failed to load profiles or countries",
          });
          return;
        }
        if (!profilesRes.ok || !countriesRes.ok) {
          ondomainData({
            errorStatus: -10,
            message: "Failed to load profiles or countries",
          });
          return;
        }
        const [profilesData, countriesData] = await Promise.all([
          profilesRes.json(),
          countriesRes.json(),
        ]);
        ondomainData(adaptToOldShape(profilesData, countriesData));
      })
      .catch((err) => {
        ondomainData({
          errorStatus: -10,
          message: (err && err.message) || "Failed to load domain data",
        });
      });
  };

  useEffect(
    getDomainData, // <- function that will run on every dependency update
    [] // <-- empty dependency array
  );
  return (
    <DomainDataContext.Provider value={inviteData}>
      {props.children}
    </DomainDataContext.Provider>
  );
};

export default DomainDataContextProvider;
